import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { getHomepageUrl } from '@as-react/common-utils';
import { CaretLeftIcon } from '@yonderland/andes-icons';
import { ButtonLink, Stack, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { CheckoutConfirmationProductsList } from './CheckoutConfirmationProductsList';
export const CheckoutConfirmationCart = ({ order }) => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const isMobile = useMediaQueryMatchesOnMobile();
    const { currency, root } = useAemConfig();
    const homepageUrl = getHomepageUrl(root);
    return (_jsxs(Stack, { gap: "6", direction: "col", justify: "start", children: [_jsx(TextAlpha, { variant: "titleXL", children: t('buy.confirmation.purchase.information.title') }), _jsx(CheckoutConfirmationProductsList, { products: order.mappedProducts, pricing: {
                    priceDelivery: order.priceDelivery,
                    priceTotalBasket: order.priceTotalBasket,
                    totalBasketDiscountAmount: order.totalBasketDiscountAmount,
                    totalPriceSell: order.totalPriceSell,
                    totalPriceSellBeforeDiscount: order.totalPriceSellBeforeDiscount,
                }, vouchers: order.vouchers, currency: currency }), _jsx("div", { children: _jsx(ButtonLink, { href: homepageUrl, testId: "continue_shopping", iconLeft: { source: CaretLeftIcon }, fullWidth: isMobile, variant: "secondary", children: t('buy.confirmation.continue.shopping') }) })] }));
};
